import React, { useState } from "react";
import styles from "./styles/info.module.css";

function Info({ message, subtitle, type, position, isBold }) {
  const [showMessage, setshowMessage] = useState(false);

  return (
    <div
      className={`${position ? styles.info_div_top : ""} ${styles.info_div}`}
    >
      <div
        onMouseEnter={() => setshowMessage(true)}
        onMouseLeave={() => setshowMessage(false)}
        className={type ? styles.info_logo_error : styles.info_logo}
      ></div>
      {showMessage ? (
        <div
          className={styles.info_message}
          style={
            isBold
              ? {}
              : {
                  fontWeight: "400",
                }
          }
        >
          <div className={styles.title}>{message}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
      ) : null}
    </div>
  );
}

export default Info;
